<template>
      <div class="yuliang" ref="yuliang">
        <div class="select">
          <!-- 类别 -->
          <div class="storageType" >
                <span class="desc">类别：</span>
                <div>
                   <el-select
                    v-model="storageType"
                    placeholder="请选择类别"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in Type"
                      :key="item.value"
                      :label="item.lable"
                      :value="item.value"
                    ></el-option>
                </el-select>
                </div>
          </div>
          <div>
            <span id="select" @click="searchData">查询</span>
          </div>
          <div class="export">
             <span @click="exportdata" id="export"><span class="export-icon"></span>导出</span>
          </div>
        </div>
        <div class="raintable">
          <el-table v-loading="loading" :row-class-name="tableRowClassName" :data="tdata" :height="height" border style="width: 100%;" :default-sort ="{prop:'overflowWarningWater',order:'descending'}">
            <el-table-column fixed type="index" width="70" label="序号" align="center" header-align="center">
            </el-table-column>
            <el-table-column fixed="" prop="stlc" align="left" header-align="left" label="乡镇" sortable min-width="120">
            </el-table-column>
            <el-table-column fixed prop="stnm" align="left" header-align="left" label="站名" sortable min-width="120">
              <template slot-scope="scope">
                <span
                  @click="stationchart(scope.row.stid)"
                  style="cursor:pointer!important;"
                  >{{ scope.row.stnm }}</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="waterAtEight_Str" align="right" header-align="right" label="8时水位" min-width="120" :sortable='true' :sort-method="sortChange1">
            </el-table-column>
            <el-table-column prop="time" align="center" header-align="center" label="当前水位时间" min-width="150" sortable>
            </el-table-column>
            <el-table-column prop="water_Str" align="right" header-align="right" label="当前水位" min-width="120" :sortable='true' :sort-method="sortChange2">
            </el-table-column>
            <el-table-column prop="warningWater_Str" align="right" header-align="right" label="汛限水位" min-width="120" :sortable='true' :sort-method="sortChange3">
            </el-table-column>
            <el-table-column prop="overflowWarningWater" align="right" header-align="right" label="超汛限水位" min-width="120" :sortable='true' :sort-method="sortChange4">
              <template slot-scope="scope">
                <font v-if="scope.row.overflowWarningWater > 0" color="red">{{scope.row.overflowWarningWater}}</font>
                <font v-else>{{scope.row.overflowWarningWater_Str}}</font>
              </template>
            </el-table-column>
              <el-table-column prop="RainfallArea" align="center" header-align="center" label="集雨面积（km²）" min-width="150" sortable>
            </el-table-column>
            <el-table-column prop="StoreLevel" align="center" label="正常水位（m）" min-width="120">
            </el-table-column>
            <el-table-column prop="NormalStorage" align="center" label="正常库容（万m³）" min-width="120">
            </el-table-column>
            <el-table-column prop="WaterStorage"  align="center" label="当前库容（万m³）" min-width="120">
            </el-table-column>
             <el-table-column prop="ImpoundmentRate" align="center" label="蓄水率" min-width="110">
            </el-table-column>
            <el-table-column prop="NetflStorage" align="center" label="可拦蓄水率（万m³）" min-width="150">
            </el-table-column>
            <el-table-column prop="NetRainfall" align="center" label="可拦蓄雨率（万m³）" min-width="150">
            </el-table-column>
          </el-table>
        </div>
        <el-dialog
      :title="thestation"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="80%">
      <!-- <span>{{thestation}}</span> -->
      <div class="block" v-loading="loading1">
        <el-radio v-model="radio" label="1" @change="hour()">小时</el-radio>
        <el-radio v-model="radio" label="2" @change="minute()">分钟</el-radio>
        <el-button @click="beforeDate" v-show="dateselect">前一天</el-button>
        <span class="demonstration"></span>
        <el-date-picker
          v-model="datev"
          v-show="dateselect"
          type="date"
          placeholder="选择日期"
          @change="datechange">
        </el-date-picker>
        <el-button @click="afterDate" v-show="dateselect">后一天</el-button>
      </div>
      <div v-loading="loading1" id="station"></div>
      <div class="chartshuiwei">
        <span>最高水位:</span><span>{{this.maxZ}}</span><span>(m)</span><span>(</span><span>{{this.maxZ_Time}}</span><span>)</span><span style="margin-left:15px;">最新水位:</span><span>{{this.lastestZ}}</span><span>(m)</span>
      </div>
    </el-dialog>
      </div>
</template>
<script>
import monitorTypes from '@/store/types/monitor'
import config from '@/config'
export default {
  name: 'MonitoringCenter',
  data () {
    return {
      maxZ_Time: '',
      lastestZ: '',
      maxZ: '',
      thestation: '',
      inputData: '',
      loading: true,
      loading1: true,
      height: 10,
      aDDVCD: '',
      stationName: '',
      isTown: true,
      searchName: '',
      tdata: [],
      all: true,
      adcdtotal: '',
      pageIndex: 1,
      pageSize: 100,
      towns: [],
      checkarr: [],
      dialogVisible: false,
      sTID: '',
      time: '',
      chartwaterValues: [],
      chartxline: [],
      chartwrZs: [],
      chartrainValues: [],
      datev: '',
      radio: '1',
      dateselect: true,
      sID: 22,
      myChart: {},
      reservoirType: '',
      storageType: '',
      seletdate: '',
      optionsType: [{
        value: '全部',
        label: '全部'
      }, {
        value: '小一型水库',
        label: '小一型水库'
      }, {
        value: '小二型水库',
        label: '小一型水库'
      }, {
        value: '大中型水库',
        label: '大中型水库'
      }],
      Type: [{
        value: '正常蓄水',
        label: '正常蓄水'
      }, {
        value: '梅汛蓄水',
        label: '梅汛蓄水'
      }, {
        value: '台汛蓄水',
        label: '台汛蓄水'
      }]
    }
  },
  computed: {
  },
  methods: {
    // 列排序
    sortChange1 (a, b) {
      return a.waterAtEight - b.waterAtEight
    },
    sortChange2 (a, b) {
      return a.water - b.water
    },
    sortChange3 (a, b) {
      return a.warningWater - b.warningWater
    },
    sortChange4 (a, b) {
      return a.overflowWarningWater - b.overflowWarningWater
    },
    beforeDate () {
      // this.n = 1
      let day1 = new Date(this.datev)
      day1.setTime(day1.getTime() - 1 * 24 * 60 * 60 * 1000)
      this.datev = day1.getFullYear() + '-' + (day1.getMonth() + 1) + '-' + day1.getDate()
      this.datechange()
    },
    afterDate () {
      // this.n = -1
      let day2 = new Date(this.datev)
      day2.setTime(day2.getTime() + 1 * 24 * 60 * 60 * 1000)
      this.datev = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate()
      this.datechange()
    },
    minute () {
      this.myChart.clear()
      this.loading1 = true
      this.dateselect = false
      this.chartwaterValues = []
      this.chartrainValues = []
      this.chartwrZs = []
      this.chartxline = []
      var date = new Date()
      // 年
      var year = date.getFullYear()
      // 月
      var month = date.getMonth() + 1
      // 日
      var day = date.getDate()
      var hh = date.getHours()
      // 分
      var mm = date.getMinutes()
      var rq = year + '-' + month + '-' + day + ' ' + hh + ':' + mm
      this.time = rq
      this.datev = rq
      this.dialogVisible = true
      this.$store.dispatch(monitorTypes.GET_RAINWATERMINUTESTOTAL, {
        sID: 22,
        sTID: this.sTID,
        time: this.time
      }).then(data => {
        this.loading1 = false
        this.chartwaterValues = data.waterValues
        this.chartrainValues = data.rainValues
        this.chartwrZs = data.wrZs
        this.chartxline = data.tMs
        this.thestation = data.stnm
        this.startWaterMark = data.startWaterMark
        var rq1 = new Date(data.maxZ_Time)
        var month1 = rq1.getMonth() + 1
        var day1 = rq1.getDate()
        var hh1 = rq1.getHours()
        var rqget = month1 + '月' + day1 + '日' + hh1 + '时'
        this.maxZ_Time = rqget
        this.maxZ = data.maxZ
        if (data.lastestZ !== undefined) {
          this.lastestZ = data.lastestZ
        } else {
          this.lastestZ = '-'
        }
        this.drawChart(this.chartwaterValues, this.chartrainValues, this.chartwrZs, this.chartxline, this.thestation)
      })
    },
    hour () {
      this.myChart.clear()
      this.loading1 = true
      this.dateselect = true
      this.chartwaterValues = []
      this.chartrainValues = []
      this.chartwrZs = []
      this.chartxline = []
      var date = new Date()
      // 年
      var year = date.getFullYear()
      // 月
      var month = date.getMonth() + 1
      // 日
      var day = date.getDate()
      var rq = year + '-' + month + '-' + day
      this.time = rq
      this.datev = rq
      this.dialogVisible = true
      this.$axios.get(config.ApiYJ + '/HydrologyCenter/GetRainWaterTotal', {
        params: {
          sID: 22,
          sTID: this.sTID,
          time: this.time
        }
      }).then(res => {
        this.loading1 = false
        var rq1 = new Date(res.data.maxZ_Time)
        var month1 = rq1.getMonth() + 1
        var day1 = rq1.getDate()
        var hh1 = rq1.getHours()
        var rqget = month1 + '月' + day1 + '日' + hh1 + '时'
        this.maxZ_Time = rqget
        this.maxZ = res.data.maxZ
        if (res.data.lastestZ !== undefined) {
          this.lastestZ = res.data.lastestZ
        } else {
          this.lastestZ = '-'
        }
        this.chartwaterValues = res.data.waterValues
        this.chartrainValues = res.data.rainValues
        this.chartwrZs = res.data.wrZs
        this.chartxline = res.data.tMs
        this.thestation = res.data.stnm
        this.startWaterMark = res.data.startWaterMark
        this.drawChart(this.chartwaterValues, this.chartrainValues, this.chartwrZs, this.chartxline, this.thestation)
      })
    },
    stationchart (dataId) {
      this.dateselect = true
      this.loading1 = true
      this.radio = '1'
      this.chartwaterValues = []
      this.chartrainValues = []
      this.chartwrZs = []
      this.chartxline = []
      this.thestation = ''
      var date = new Date()
      // 年
      var year = date.getFullYear()
      // 月
      var month = date.getMonth() + 1
      // 日
      var day = date.getDate()
      var rq = year + '-' + month + '-' + day
      this.time = rq
      this.datev = rq
      this.sTID = dataId
      this.dialogVisible = true
      this.$axios.get(config.ApiYJ + '/HydrologyCenter/GetRainWaterTotal', {
        params: {
          sID: 22,
          sTID: this.sTID,
          time: this.time
        }
      }).then(res => {
        this.loading1 = false
        this.chartwaterValues = res.data.waterValues
        this.chartrainValues = res.data.rainValues
        this.chartwrZs = res.data.wrZs
        this.chartxline = res.data.tMs
        this.thestation = res.data.stnm
        this.startWaterMark = res.data.startWaterMark
        this.drawChart(this.chartwaterValues, this.chartrainValues, this.chartwrZs, this.chartxline, this.thestation)
        this.hour()
      })
    },
    datechange () {
      this.time = this.datev
      this.myChart.clear()
      this.loading1 = true
      this.chartwaterValues = []
      this.chartrainValues = []
      this.chartwrZs = []
      this.chartxline = []
      this.dialogVisible = true
      this.$axios.get(config.ApiYJ + '/HydrologyCenter/GetRainWaterTotal', {
        params: {
          sID: 22,
          sTID: this.sTID,
          time: this.time
        }
      }).then(res => {
        this.loading1 = false
        this.chartwaterValues = res.data.waterValues
        this.chartrainValues = res.data.rainValues
        this.chartwrZs = res.data.wrZs
        this.chartxline = res.data.tMs
        this.thestation = res.data.stnm
        this.startWaterMark = res.data.startWaterMark.toFixed(2)
        this.drawChart(this.chartwaterValues, this.chartrainValues, this.chartwrZs, this.chartxline, this.thestation)
      })
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.overflowWarningWater > 0) {
        console.log(row.overflowWarningWater)
        return 'warning-row'
      }
      return ''
    },
    nameSelect () {
      this.stationName = this.inputData
      this.tabledata()
    },
    searchData () {
      this.stationName = this.inputData
      this.tabledata()
    },
    towndata () {
      let arr = []
      this.$store.dispatch(monitorTypes.GET_ADCD, {
        isTown: this.isTown,
        searchName: this.searchName,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }).then(data => {
        this.adcdtotal = data.total
        this.towns = data.results
        this.towns.forEach(item => {
          let obj = { adcd: '', adnm: '', id: 0, lat: 0.0, lng: 0.0, modifyTime: '', check: false }
          obj.adcd = item.adcd
          obj.adnm = item.adnm
          obj.id = item.id
          arr.push(obj)
        })
        this.towns = arr
      })
    },
    tabledata () {
      this.loading = true
      this.$store.dispatch(monitorTypes.GET_STATISTICS_RESERVOIR_WATER, {
        sID: this.sID,
        aDDVCD: this.aDDVCD,
        orderField: 'overflowWarningWater',
        stationName: this.stationName
      }).then(data => {
        console.log(data, '水库水情数据')
        this.tdata = data.rows
        this.dataSort('overflowWarningWater', this.tdata)
        this.loading = false
      })
    },
    setListCheck: function (idx, adcd) {
      this.loading = true
      this.all = false
      var check = this.towns[idx].check
      this.towns[idx].check = !check
      let checknum = this.thecheck()
      this.addcheckarr(adcd, this.towns[idx].check)
      // console.log(adcd, this.towns[idx].check)
      // 拼接截取
      if (this.checkarr !== undefined && this.checkarr.length !== 0) {
        this.aDDVCD = ''
        this.checkarr.forEach((item) => {
          this.aDDVCD += item.substring(0, 9) + ','
        })
        this.aDDVCD = this.aDDVCD.substring(0, this.aDDVCD.length - 1)
        this.tabledata()
      }
      // 0或全选 变为全部
      if (checknum === this.adcdtotal || checknum === 0) {
        this.setAllCheck()
      }
    },
    addcheckarr: function (adcd, state) {
      console.log(adcd, state)
      if (state) {
        this.checkarr.push(adcd)
      } else {
        this.deletecheckarr(adcd)
      }
    },
    deletecheckarr: function (adcd) {
      if (this.checkarr !== undefined && this.checkarr.length !== 0) {
        this.checkarr.forEach((item, index) => {
          if (item === adcd) {
            this.checkarr.splice(index, 1)
          }
        })
      }
    },
    setAllCheck: function () {
      this.all = true
      this.checkarr = []
      this.aDDVCD = ''
      this.towns.forEach((item) => {
        item.check = false
      })
      this.tabledata()
    },
    thecheck: function () {
      let num = 0
      this.towns.forEach((item) => {
        if (item.check) {
          num++
        }
      })
      return num
    },
    // 数据排序
    dataSort (type, sortData) {
      this.sortType = type
      sortData.sort(this.compare(type))
    },
    compare (attr) {
      return function (a, b) {
        var val1 = a[attr]
        var val2 = b[attr]
        return val2 - val1
      }
    },
    // 折线图
    drawChart (chartwaterValues, chartrainValues, chartwrZs, chartxline, thestation) {
      let myChart = this.$echarts.init(document.getElementById('station'))
      this.myChart = myChart
      myChart.clear()
      myChart.setOption({
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['雨量', '水位', '警戒水位'],
          orient: 'vertical',
          x: 'left',
          y: 'center',
          padding: [0, 0, 0, 0],
          itemWidth: 10
        },
        grid: {
          top: '10%',
          left: '8%',
          right: '4%',
          bottom: '12%'
        },
        xAxis: [
          {
            type: 'category',
            // boundaryGap: false,
            data: chartxline,
            axisLabel: {
              interval: 0,
              formatter: function (params) {
                var newParamsName = ''
                var paramsNameNumber = params.length
                var provideNumber = 6
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber)
                if (paramsNameNumber > provideNumber) {
                  for (var p = 0; p < provideNumber; p++) {
                    var tempStr = ''
                    var start = p * provideNumber
                    var end = start + provideNumber
                    if (p === rowNumber - 1) {
                      tempStr = params.substring(start, paramsNameNumber)
                    } else {
                      tempStr = params.substring(start, end) + '\n'
                    }
                    newParamsName += tempStr
                  }
                } else {
                  newParamsName = params
                }
                return newParamsName
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '水位',
            min: this.startWaterMark,
            scale: false,
            interval: 100,
            axisLabel: {
              formatter: '{value} m'
            }
          },
          {
            type: 'value',
            name: '雨量',
            max: function (value) {
              return Math.round(value.max * 1.5)
            },
            nameLocation: 'start',
            inverse: true, // 翻转
            interval: 30,
            axisLabel: {
              formatter: '{value} mm'
            }
          }
        ],
        series: [
          {
            name: '雨量',
            type: 'bar',
            yAxisIndex: 1,
            itemStyle: {
              color: '#33C9DE'
            },
            data: chartrainValues
          },
          {
            name: '水位',
            type: 'line',
            symbol: 'circle',
            symbolSize: 10,
            itemStyle: {
              borderWidth: 2,
              color: '#15d186'
            },
            lineStyle: {
              width: 3
            },
            data: chartwaterValues
          },
          {
            name: '警戒水位',
            type: 'line',
            symbol: 'none',
            itemStyle: {
              color: '#f4e74c'
            },
            lineStyle: {
              width: 3
            },
            data: chartwrZs
          }
        ]
      })
    },
    exportdata () {
      this.$store.dispatch(monitorTypes.EXPORT_RESERVOIR_WATER, {
        aDDVCD: this.aDDVCD,
        stationName: this.stationName
      }).then(data => {
        window.location.href = this.Global.basePath + data.data
        // window.location.href
      })
    }
  },
  mounted () {
    this.towndata()
    this.tabledata()
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      let countryListDiv = document.getElementsByClassName('countryList')
      this.$refs['yuliang'].style.height = (contentDiv[0].offsetHeight - countryListDiv[0].offsetHeight - 45) + 'px'
      let selectDiv = document.getElementsByClassName('select')
      this.height = this.$refs['yuliang'].offsetHeight - selectDiv[0].offsetHeight - 20
    })
  }
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped></style>
<style lang="less" scoped>
.monitor{
  .content{
    .yuliang{
      .select{
        display: flex;
        position: relative;
        .el-input{
          width: 165px;
        }
        .export {
          position: absolute;
          right: 0;
        }
        div.storageType{
          display: flex;
          position: relative;
          bottom: 8px;
          div{
            width:180px;
          }
        }
      }
    }
  }
}
// 样式穿透
.content /deep/ .yuliang .raintable .el-table .warning-row{
  background:#f3f364 !important;
}
#station{
  width: 100%;
  height: 400px;
}
.block{
  position: absolute;
  width: 95%;
  top: 15px;
  left: 0;
  text-align: center;
}
.chartshuiwei{
    text-align: center;
    width: 100%;
    // text-align: center;
  }
</style>
